import { ADMIN_URL,APP_BASE_URL } from '../../config/api';
import { authFetch } from '../../utils/api';

const THRESHOLDS_URL = `${APP_BASE_URL}${ADMIN_URL}/thresholds`;
const ENTITIES_URL = `${APP_BASE_URL}${ADMIN_URL}/entities`;

export async function listThresholds(accountId) {
  try {
    if (!accountId) {
      throw new Error("Entity ID is required");
    }
    const res = await authFetch(`${ENTITIES_URL}/${accountId}/thresholds`);
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to fetch thresholds");
    }
    return res.json();
  } catch (error) {
    console.error(`Threshold fetch error for entity ${accountId}:`, error);
    throw error;
  }
}

export async function createThreshold(payload) {
  try {
    if (!payload.account_id) {
      throw new Error("Entity ID is required in payload");
    }
    const res = await authFetch(THRESHOLDS_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to create threshold");
    }
    return res.json();
  } catch (error) {
    console.error("Threshold creation error:", error);
    throw error;
  }
}

export async function createDefaultThresholds(accountId) {
  try {
    if (!accountId) {
      throw new Error("Entity ID is required");
    }
    const res = await authFetch(`${ENTITIES_URL}/${accountId}/default-thresholds`, {
      method: "POST",
      headers: { "Content-Type": "application/json" }
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to create default thresholds");
    }
    return res.json();
  } catch (error) {
    console.error(`Default thresholds creation error for entity ${accountId}:`, error);
    throw error;
  }
}

export async function updateThreshold(id, payload) {
  try {
    if (!id) {
      throw new Error("Threshold ID is required");
    }
    const res = await authFetch(`${THRESHOLDS_URL}/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to update threshold");
    }
    return res.json();
  } catch (error) {
    console.error(`Threshold update error for ID ${id}:`, error);
    throw error;
  }
}

export async function deleteThreshold(id) {
  try {
    if (!id) {
      throw new Error("Threshold ID is required");
    }
    const res = await authFetch(`${THRESHOLDS_URL}/${id}`, {
      method: "DELETE"
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to delete threshold");
    }
  } catch (error) {
    console.error(`Threshold deletion error for ID ${id}:`, error);
    throw error;
  }
}